import * as styles from "./VolunteerVacancySimpleCard.module.scss";

import React from "react";

import { Chevron } from "../../../components/common/Icons";
import { Colours } from "../../../utils/colours";

export interface VolunteerVacancyCardProps {
	date: string;
	title: string;
	url: string;
}
export const VolunteerVacancyCardSimple: React.FC<
	VolunteerVacancyCardProps
> = ({ title, url }) => {
	return (
		<a href={url} className={styles.volunteervacancycard}>
			<div className={styles.volunteervacancycardtext}>
				<h2
					data-variation="hideFromJumpLinks"
					className={styles.volunteervacancytitle}
				>
					{title}
				</h2>
			</div>
			<div className={styles.volunteervacancylink}>
				<Chevron
					rotation={90}
					height={"30px"}
					width={"30px"}
					fill={Colours.SUNSHINE_YELLOW}
				/>
			</div>
		</a>
	);
};
export default VolunteerVacancyCardSimple;
